import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Col, Row, Card, Form, InputGroup, Container, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from '../ChargeHistory'
import { useCookies } from 'react-cookie';
import { getAllChargeUser } from '../../../../../controller/api/charge';

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _phone = useRef(state.filter.phone);
  const _method = useRef(state.filter.method);
  const _chargeType = useRef(state.filter.chargeType);
  const _chargeUserId = useRef(state.filter.chargeUserId);

  const [cookies] = useCookies(['lottmekong'])
  const [listChargeUser, setListChargeUser] = useState([])
  const [selectedChargeType, setSelectedChargeType] = useState(state.filter.chargeType || '')

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload
  }, [])

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _handleChangeMethod = useCallback((payload) => {
    _method.current = payload.target.value
  }, [])

  const _handleChangeChargeType = useCallback((payload) => {
    _chargeType.current = payload.target.value
    setSelectedChargeType(payload.target.value)
    if (payload.target.value !== 'MANUAL') {
      _chargeUserId.current = ''
    }
  }, [])

  const _handleChangeChargeUserId = useCallback((payload) => {
    _chargeUserId.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from: _from.current,
        to: _to.current,
        phone: _phone.current,
        method: _method.current,
        chargeType: _chargeType.current,
        chargeUserId: _chargeUserId.current
      }
    })
  }, [dispatch])

  useEffect(() => {
    const getChargeUsers = async () => {
      const response = await getAllChargeUser(cookies.lottmekong)
      if (response && response.data) {
        setListChargeUser(response.data)
      }
    }

    getChargeUsers()
  }, [cookies.lottmekong])

  const _exportForm = () => {
    dispatch({
      type: 'EXPORT_DATA'
    })
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>LỊCH SỬ NẠP TIỀN APP</h5>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
              {/* <Button style={{ marginRight: 20 }} variant="success" type="button" onClick={_exportForm}>Xuất file</Button> */}
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Container>
            <Col>
              <Row className='p-1'>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Từ ngày</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Datetime
                        timeFormat={false}
                        onChange={_handleChangeFrom}
                        renderInput={(props, openCalendar) => (
                          <InputGroup>
                            <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                            <Form.Control
                              required
                              type="text"
                              value={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                              placeholder="dd/mm/yyyy"
                              onFocus={openCalendar}
                              onChange={() => { }} />
                          </InputGroup>
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Đến ngày</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Datetime
                        timeFormat={false}
                        onChange={_handleChangeTo}
                        renderInput={(props, openCalendar) => (
                          <InputGroup>
                            <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                            <Form.Control
                              required
                              type="text"
                              value={_to.current ? moment(_to.current).format("DD/MM/YYYY") : ""}
                              placeholder="dd/mm/yyyy"
                              onFocus={openCalendar}
                              onChange={() => { }} />
                          </InputGroup>
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='p-1'>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Số điện thoại</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control onChange={_handleChangePhone} required type="text" placeholder="Nhập số điện thoại (Để trống để tìm tất cả)" />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Hình thức</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Select onChange={_handleChangeMethod}>
                        <option defaultValue value={''}>Chọn tất cả</option>
                        <option value={'BANKING'}>Chuyển khoản ngân hàng</option>
                        <option value={'APPOTAPAY'}>APPOTA</option>
                        <option value={'GPAY'}>GPAY</option>
                        <option value={'VNPTPAY'}>VNPTPAY</option>
                        <option value={'MOMOPAY'}>MOMO</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Loại nạp</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Select onChange={_handleChangeChargeType}>
                        <option defaultValue value={''}>Chọn tất cả</option>
                        <option value={'AUTO'}>Tự động</option>
                        <option value={'MANUAL'}>Thủ công</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>
                {selectedChargeType === 'MANUAL' &&
                  <Col>
                    <Row>
                      <Col md={3} className='text-right align-self-center'>
                        <Form.Label>Người nạp</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Select onChange={_handleChangeChargeUserId}>
                          <option defaultValue value={''}>Chọn tất cả</option>
                          {listChargeUser.map((it) => (
                            <option key={it.id} value={it.id}>
                              {it.name} ({it.username})
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                }
              </Row>
            </Col>
          </Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)